import { render } from "./Favorites.vue?vue&type=template&id=557b02f3&scoped=true"
import script from "./Favorites.vue?vue&type=script&lang=js"
export * from "./Favorites.vue?vue&type=script&lang=js"

import "./Favorites.vue?vue&type=style&index=0&id=557b02f3&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-557b02f3"

export default script